export default {
  title: 'Commencer',
  description: 'Pour accéder à cette page, vous devez compléter le guide de démarrage',
  button: 'Commencer',
};
